<script>
    import { blur } from "svelte/transition";
    import ImageIcon from "../icons/image.svelte";
    import { inViewport } from "../../utils";
    let cls = "sui-image";
    let showLazy = false;
    //props
    export let src = "";
    export let alt = "";
    export let lazy = false;
    /*
        'contain' | 'cover' | 'fill' | 'none' | 'scale-down'
    */
    export let fit = "fill";
    export let width = "auto";
    export let height = "auto";
    export let borderRadius = "0px";
    export let unobserveOnEnter = true;
    
    // 异步获取图片
    async function loadImage() {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = src;
            if (img.complete) {
                resolve();
            }
            img.onload = () => {
                resolve(img.naturalWidth,img.naturalHeight);
            };
        });
    }
</script>

<div
    class={`${cls}-wrapper-hooks`}
    use:inViewport={{ unobserveOnEnter, lazy }}
    on:enter={(e) => (showLazy = e.detail.inView)}
>
    {#if lazy}
        {#if showLazy}
            {#if src}
                {#await loadImage()}
                    <div
                        class={`${cls}-wrapper`}
                        style:width
                        style:height
                        style:border-radius={borderRadius}
                        style:--background-color="var(--sui-color-box)"
                    >
                        <ImageIcon size={24} />
                    </div>
                {:then value}
                    <div
                        class={`${cls}-wrapper`}
                        style:width
                        style:height
                        style:border-radius={borderRadius}
                    >
                        <img
                            transition:blur={{ amount: 30 }}
                            style:object-fit={fit}
                            style:width
                            style:height
                            class={cls}
                            {src}
                            {alt}
                        />
                    </div>
                {/await}
            {/if}
        {/if}
    {:else if src}
        {#await loadImage()}
            <div
                class={`${cls}-wrapper`}
                style:width
                style:height
                style:border-radius={borderRadius}
                style:--background-color="var(--sui-color-box)"
            >
                <ImageIcon size={24} />
            </div>
        {:then value}
            <div
                class={`${cls}-wrapper`}
                style:width
                style:height
                style:border-radius={borderRadius}
            >
                <img
                    transition:blur={{ amount: 30 }}
                    style:object-fit={fit}
                    style:width
                    style:height
                    class={cls}
                    {src}
                    {alt}
                />
            </div>
        {/await}
    {/if}
</div>

<style lang="less">
    @import "./image.less";
</style>
